import React, { Suspense } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import './App.css';
import JoinLandingContainer from './containers/join/JoinLandingContainer';
import JoinPhoneContainer from './containers/join/JoinPhoneContainer';
import JoinVerifyContainer from './containers/join/JoinVerifyContainer';
import JoinNameContainer from './containers/join/JoinNameContainer';
import JoinHandoffContainer from './containers/join/JoinHandoffContainer';
import ConnectContainer from './containers/connect/ConnectContainer';

// Everything that is not the invite flow lives in its own chunk (see MainApp.jsx
// for why). Fallback is null: the receipt pages render their own loading states,
// and a flash of spinner on top of that would be worse than nothing.
const MainApp = React.lazy(() => import('./MainApp'));

export default function App() {
  return (
    <Router>
      <Switch>
        {/* Group invite flow — isolated from main app chrome (no Header, no AuthProvider).
            Canonical URL the app mints: /groups/join/{gid}?inviter={uid} */}
        <Route path="/groups/join/:gid" exact>
          <JoinLandingContainer />
        </Route>
        <Route path="/groups/join/:gid/phone" exact>
          <JoinPhoneContainer />
        </Route>
        <Route path="/groups/join/:gid/verify" exact>
          <JoinVerifyContainer />
        </Route>
        <Route path="/groups/join/:gid/name" exact>
          <JoinNameContainer />
        </Route>
        <Route path="/groups/join/:gid/app" exact>
          <JoinHandoffContainer />
        </Route>

        {/* OAuth consent page for assistants (ChatGPT): sign in by phone, then
            Allow or Not now. Same isolation as the join flow: no AuthProvider. */}
        <Route path="/connect/:requestId" exact>
          <ConnectContainer />
        </Route>

        <Route>
          <Suspense fallback={null}>
            <MainApp />
          </Suspense>
        </Route>
      </Switch>
    </Router>
  );
}
